


      <h2 mat-dialog-title class="dialog-title">
        <div class="changelog">Changelog</div>
        <div *ngIf="versions">
          <button class="outlined"
                  *ngFor="let version of versions; let i = index"
                  (click)="onVersionClick(i)">
            <span class="badge" *ngIf="!version.seen">!</span>
            <span class="mat-button__label">{{ version.title }}</span>
          </button>
        </div>
        <div *ngIf="!versions">
          Keine Daten verfügbar
        </div>
      </h2>
      <mat-dialog-content class="dialog-content">
        <app-version></app-version>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
        <button class="plain" mat-button mat-dialog-close>Schließen</button>
      </mat-dialog-actions>



